import { render, staticRenderFns } from "./BigQuestion.vue?vue&type=template&id=98252a92&scoped=true&"
import script from "./BigQuestion.vue?vue&type=script&lang=js&"
export * from "./BigQuestion.vue?vue&type=script&lang=js&"
import style0 from "./BigQuestion.vue?vue&type=style&index=0&id=98252a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98252a92",
  null
  
)

export default component.exports